export function localEnvironment(countryCode) {
  const baseConfig = {
    exrEnv: 'dev',
    exrServiceApi: 'http://localhost:8080/',
    submitAppPath: 'api/prequalify/rest/submit-application',
    exploreVehiclesTarget: 'https://shop.ford.com/showroom/',
    onlineCreditApplicationTarget: 'https://wwwqa.oca.ford.com/finance/apply/',
    oneTrustCookieLawSrc: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    warningTimeMilliseconds: '6000000',
    sessionEndTimeMilliseconds: '12000000',
    optimizelyKey: 'SCzEuGCuiJyjsj3BPPraW',
    mouseflowKey: '9fdf02dc-241d-4f2d-833b-2216e458dddf',
    exploreFinancing: 'https://www.ford.com/finance/finance-options',
    prepopulateApprovedCustomerTestDataUSA: true,
    prepopulateCreditFreezeCustomerTestDataUSA: false,
    prepopulateApprovedCustomerTestDataCAN: true,
    prepopulateCreditFreezeCustomerTestDataCAN: false, // Test data only works Mon-Wed
    prepopulateQuebecCreditFreezeCustomerTestDataCAN: false,
    modalFlag: false,
    exrTarget: 'http://localhost:3000/finance/prequalify',
    shopTarget: 'https://shop.ford.com/showroom/',
    ocaTarget: 'https://wwwqa.oca.ford.com/finance/apply/',
    showShadow: true,
    AEM_PAGE_PATH: '/content/webplatform/ecommerce/qualify',
    AEM_PUBLISHER_URL: 'https://wwwdev.creditbrandlb.ford.com',
    appModalURL: 'http://localhost:3002/webcompbutton/prequal-app-modal.js',
    minifiedCSSURL: 'http://localhost:3002/webcompbutton/prequal-app.css',
    modelForApply: true,
    maintenanceModal: false,
    removeVehicleTrimInfoFlag: true,
    specialEventFlag: true,
    specialEventTarget: 'https://www.buyfordnow.com/salesevent',
    vehicleChooserVariation: 'vehicle_chooser_a_b',
    isAdobeSuiteFlag: false,
    modalUpdateFlag: true,
    reCaptchaFlag: true,
    recaptchaVariation: 'exp_id_-_87'
  };

  baseConfig.countryCode = countryCode;
  baseConfig.adobeSrc = baseConfig.isAdobeSuiteFlag
    ? 'https://assets.adobedtm.com/248d63c2ff6b/01cce4ecbac0/launch-008d4b5e73d2-development.min.js'
    : 'https://assets.adobedtm.com/248d63c2ff6b/01cce4ecbac0/launch-EN99ca62c1c00b40a999d0e196225b4fa6-staging.min.js';
  return baseConfig;
}
